import gql from 'graphql-tag'


export const NewChatMessage = gql`
    mutation newChatMessage($to: ID!, $channelId: String!, $message: String, $fileName: String) {
      newChatMessage(to: $to, channelId: $channelId, message: $message, fileName: $fileName)
    }
`
